// extracted by mini-css-extract-plugin
var _1 = "countLink--zPX3J";
var _2 = "dependencyCounts--eOPcn";
var _3 = "separator--WAbOo";
var _4 = "warningBanner--humel";
var _5 = "warningContent--IifqL";
var _6 = "warningIcon--p5F9T";
var _7 = "warningMessage--SLb4q";
export { _1 as "countLink", _2 as "dependencyCounts", _3 as "separator", _4 as "warningBanner", _5 as "warningContent", _6 as "warningIcon", _7 as "warningMessage" }
